<div
	class="app-container"
	[ngClass]="{
		tabbar: showTabbar,
		'side-panel-small': openPanel() && (isTablet || isTabletWide) && !isDesktop,
		'side-panel-full': openPanel() && isDesktop
	}"
>
	<aside [ngClass]="{ 'sidebar-none': !showSidebar }">
		<sp-sidebar [menu]="sidebarMenu" (selection)="onSelection($event)"></sp-sidebar>
	</aside>

	<main class="app-content" [ngClass]="{ 'sidebar-show': showSidebar }">
		@if (isLoading === true) {
			@defer {
				<sp-notification [isVisible]="showNetworkStatus" (finishTimer)="handleFinishTimer()"></sp-notification>
			}
		}
		@if (showErrorPage === true) {
			<sp-issues></sp-issues>
		} @else {
			<router-outlet></router-outlet>
		}

		<sp-side-panel #sidePanel [style.display]="isMobile ? 'none' : 'block'"></sp-side-panel>

		<div class="app-footer"></div>
	</main>

	<div [ngClass]="{ 'tabbar-none': !showTabbar }">
		<sp-tabbar [isIOSStandalone]="isIOSStandalone" [isAndroidStandalone]="isAndroidStandlone"></sp-tabbar>
	</div>
</div>

<sp-toast></sp-toast>

<sp-upgrade-modal
	[isVisible]="upgradeModalService.isVisible"
	[previousRoute]="upgradeModalService.previousRoute()"
	(closed)="upgradeModalService.close()"
></sp-upgrade-modal>
